module.exports = __webpack_public_path__ + "static/media/badge_level_3_1.dabbef9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_level_3_1.png
// module id = 489
// module chunks = 0